




































import { Vue, Component, Prop } from "vue-property-decorator";
import { Action as IAction } from "@/api-v2/learning-requests/models";
import CustomButton from "@/components/form/CustomButton.vue";
import ProfileStatusForm from "@/components/learning-request-v2/ProfileStatusForm.vue";
import { learningRequestApi } from "@/getinfo-api";
import Modal from "@/components/form/Modal.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";

@Component({ components: { Modal, ProfileStatusForm, CustomButton } })
export default class ProfileStatusEdit extends Vue {
  @Prop() statuses!: any;
  @Prop() actions!: Array<IAction>;
  @Prop() status!: any;
  @Prop() profile!: any;
  @Prop() index!: number;
  @Prop() isSortedProcess!: boolean;
  isShowEdit: boolean = false;
  isLoading: boolean = false;

  remove() {
    learningRequestApi.StatusProfiles.deleteStatus(
      this.profile.id,
      this.status.id
    )
      .then(() => {
        this.$emit("statusRemove");
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  editStatus(form: any) {
    this.isLoading = true;
    learningRequestApi.StatusProfiles.editStatus(
      this.profile.id,
      this.status.id,
      form
    ).finally(() => {
      this.isShowEdit = false;
      this.isLoading = false;
    });
  }
}
